import React, { useCallback } from "react";
import { PopoverDisclosure, usePopoverState } from "reakit/Popover";
import { PeriodRange, PeriodType } from "@linkfluence/models/date";
import { Locale } from "@linkfluence/models/locale";
import { Milestone, getMilestone } from "@linkfluence/models/milestone";
import { Timezone } from "@linkfluence/models/timezone";
import Date from "@ui-kit/format/date";
import PeriodSelector from "@ui-kit/period-selector";
import Popover from "@ui-kit/popover";
import Button from "./gigantic-button";

interface IProps {
  period: PeriodRange;
  timezone: Timezone;
  locale: Locale;
  onChange: (period: PeriodRange) => void;
  limits?: PeriodRange;
  milestones: Milestone[];
  customPeriod?: boolean;
  customHour?: boolean;
  allowBeyondLimit?: boolean;
  hiddenPeriods?: PeriodType[];
  limitTo100Days?: boolean;
}

const FilterbarPeriodSelector = ({
  period,
  milestones,
  locale,
  timezone,
  onChange,
  ...props
}: IProps) => {
  const popover = usePopoverState({ placement: "bottom-start" });
  const onChangePeriod = useCallback(
    (period: PeriodRange) => {
      popover.hide();
      onChange(period);
    },
    [onChange, popover]
  );
  const currentMilestone = getMilestone(period.from, period.to, milestones);
  return (
    <>
      <PopoverDisclosure
        {...popover}
        as={Button}
        maxWidth={2000}
        label={
          currentMilestone ? (
            currentMilestone.name
          ) : (
            <Date
              locale={locale}
              timezone={timezone}
              from={period.from}
              to={period.to}
            />
          )
        }
        glyph="calendar"
        hasChevron
      />
      <Popover popover={popover} ariaLabel="period-selector">
        <PeriodSelector
          {...props}
          period={period}
          locale={locale}
          timezone={timezone}
          milestones={milestones}
          opened={popover.visible}
          onChange={onChangePeriod}
          onClose={popover.hide}
        />
      </Popover>
    </>
  );
};

export default FilterbarPeriodSelector;
